export const DefaultProtocolGroups = {
  standard: 1,
  qualityControl: 2,
};
